import styled from 'styled-components'

import { fontSize, fontWeight } from 'src/styles/fonts'
import { color } from 'src/styles/colors'

export const SmallLabel = styled.span`
  font-size: ${fontSize.SMALL};
  font-weight: ${fontWeight.BOLD};
  color: ${color.WARM_GREY};
  margin-top: 5.5rem;
`

export const MatchWrap = styled.span`
  font-size: 5.6rem;
  font-weight: ${fontWeight.EXTRA};
  color: ${color.GREYISH_BROWN};
  margin: 2.9rem 0 2.5rem;
  line-height: 1;
`

export const NameWrap = styled.span`
  font-size: ${fontSize.LARGE_XXXL};
  color: ${color.GREYISH_BROWN};
  font-weight: ${fontWeight.EXTRA};
  line-height: 1;
  margin: 2.3rem 0 0.8rem;
`

export const LocationWrap = styled.span`
  color: ${color.WARM_GREY};
  line-height: 1;
  margin: 1.6rem 0;
`
